import { ChangeDetectionStrategy, Component, contentChild, input, TemplateRef } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

import { CommonModule } from '@angular/common';

import { GetInterpolatedString } from '@pinnakl/shared/util-helpers';
import { observeControl } from '../../forms';

const BaseValidationErrors: Record<string, string> = {
  required: 'This field is required',
  minlength: 'Minimum required length is {{requiredLength}}',
  maxlength: 'Maximum length is {{requiredLength}}',
  min: 'Minimum allowed value is {{min}}',
  max: 'Maximum allowed value is {{max}}',
  greaterThan: 'Should be greater than {{value}}',
  pattern: 'Invalid data',
  emptySpace: 'This field is required',
  url: 'Enter a valid URL',
  email: 'Enter a valid email address',
};

@Component({
  selector: 'prime-input-validation',
  imports: [CommonModule],
  templateUrl: './input-validation.component.html',
  styleUrls: ['./input-validation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputValidationComponent {
  readonly control = input.required<AbstractControl>();
  readonly hintContent = contentChild<TemplateRef<null> | null>('hintContent');
  readonly hintLabel = input<string>('');
  readonly reserveHeight = input<boolean>(true);
  readonly showAmountSection = input<boolean>(false);
  readonly errorClasses = input<string>('');
  readonly maxLengthHintValue = input<number | undefined>(undefined);
  readonly customErrors = input<Record<string, string> | undefined>(undefined);

  constructor() {
    observeControl(this.control);
  }

  get errorMsg(): string {
    const errors = this.control().errors;
    if (errors) {
      const errorsKeysArray = Object.keys(errors);
      const flattedErrors: Record<string, string | number | boolean> = errorsKeysArray.reduce(
        (flattedErrors, errorKey) => ({
          ...flattedErrors,
          ...errors[errorKey],
        }),
        {},
      );

      if (errorsKeysArray.length) {
        const key = errorsKeysArray[0];

        if (errors[key]) {
          const customErrors = this.customErrors();
          return GetInterpolatedString(
            customErrors?.[key] ? customErrors[key] : BaseValidationErrors[key],
            flattedErrors,
          );
        }
        return '';
      }
      return '';
    }
    return '';
  }

  get dirty(): boolean {
    return !!this.control()?.dirty;
  }

  get errors(): ValidationErrors | null | undefined {
    return this.control()?.errors;
  }

  get valueLength(): string {
    return this.control()?.value?.trim?.()?.length?.toString() ?? '';
  }
}
